<template>
  <footer class="footer footer-transparent d-print-none">
    <div class="container-xl">
      <div class="row text-center align-items-center">
        <!-- Right: Links -->
        <div class="mt-3 mt-lg-0">
          <ul class="list-inline list-inline-dots mb-0">
            <li class="list-inline-item">
              <a href="#" class="link-secondary"></a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </footer>
</template>
